import React, { useState } from 'react';
import catDerpHehehe from '../assets/Q5/cat_derp_hehehe.gif';
import catDerpHehehe2 from '../assets/Q5/cat_derp_hehehe2.gif';
import catExplosion from '../assets/Q5/cat_explosion.gif';

function Q5({ question = 5, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);
  const [yes1Checked, setYes1Checked] = useState(false);
  const [yes2Checked, setYes2Checked] = useState(false);

  const gifSrc = yes1Checked && yes2Checked
    ? catExplosion
    : yes1Checked
      ? catDerpHehehe
      : yes2Checked
        ? catDerpHehehe2
        : null;

  const buttonText = yes1Checked && yes2Checked
    ? 'YEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEESSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS!'
    : yes1Checked
      ? 'Yeah hehehe'
      : yes2Checked
        ? 'Yas hihihi'
        : 'Yes';

  return (
    <div className="dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I'm a cute title uwu</span>
        <h1>Project Valen</h1>
        <p>You don't? Pfft</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q5__center">
      <span className="secretpin__title q5__greeting">Want to find out?</span>
      <div className="q2__options q5__options">
        <label className="q2__option" htmlFor="q5-yes1">
          <input
            id="q5-yes1"
            type="checkbox"
            checked={yes1Checked}
            onChange={(e) => setYes1Checked(e.target.checked)}
          />
          <span className="q2__option-label">Yes</span>
        </label>
        <label className="q2__option" htmlFor="q5-yes2">
          <input
            id="q5-yes2"
            type="checkbox"
            checked={yes2Checked}
            onChange={(e) => setYes2Checked(e.target.checked)}
          />
          <span className="q2__option-label">Yes</span>
        </label>
      </div>
      <button
        type="button"
        className="dashboard__button dashboard__button--primary home__button q5__wave-button"
        onClick={() => onNavigate?.('q6')}
      >
        {buttonText}
      </button>
      {gifSrc && <img src={gifSrc} alt="" className="q5__gif" />}
    </div>
  </div>
  );
}

export default Q5;
